/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const FullBodyCircleSolidBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm-.003-13.5c1.035 0 1.874-.784 1.874-1.75S13.03 5 11.997 5c-1.035 0-1.874.784-1.874 1.75s.839 1.75 1.874 1.75Zm0 6.43-.908 3.807a.371.371 0 0 1-.362.263H9.192c-.225 0-.4-.184-.372-.393l.976-7.35-3.49-.61c-.204-.036-.338-.219-.3-.409l.277-1.376c.038-.19.234-.315.437-.28l4.316.756a4.857 4.857 0 0 0 1.928 0l4.316-.756c.203-.035.4.09.437.28l.277 1.376c.038.19-.096.373-.3.409l-3.49.61.976 7.35c.027.209-.147.393-.372.393h-1.535a.371.371 0 0 1-.362-.263l-.914-3.808Z" /></svg>);
const FullBodyCircleSolid = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={FullBodyCircleSolidBase} {...rest} ref={ref} />);
export default FullBodyCircleSolid;